import { useSyncExternalStore } from 'react';
import type { EmailCampaignPreviewCardData } from './email-review';
import { closeSitePane } from './site-edit-store';

export type EmailReviewSendResult =
  | { status: 'sent' }
  | { status: 'busy' }
  | { status: 'answered' }
  | { status: 'newer'; card: EmailCampaignPreviewCardData; sendComments: SendEmailComments };

export type SendEmailComments = (message: string) => EmailReviewSendResult;

export interface EmailReviewFlow {
  card: EmailCampaignPreviewCardData;
  workspaceId: string;
  conversationId: string | null;
  sendComments?: SendEmailComments;
  beside: boolean;
}

let flow: EmailReviewFlow | null = null;
const listeners = new Set<() => void>();

function set(next: EmailReviewFlow | null): void {
  flow = next;
  for (const l of [...listeners]) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function openEmailReview(next: EmailReviewFlow): void {
  if (next.beside) closeSitePane();
  set(next);
}

export function closeEmailReview(): void {
  set(null);
}

export function closeEmailReviewBeside(): void {
  if (flow?.beside) set(null);
}

export function useEmailReviewFlow(): EmailReviewFlow | null {
  return useSyncExternalStore(subscribe, () => flow, () => null);
}
